import { BillingPlan } from '@cycle-app/graphql-codegen';
import { typo, boxShadowZ1 } from '@cycle-app/ui';
import styled from 'styled-components';

export const Container = styled.div<{ $plan?: BillingPlan }>`
  align-items: center;
  border-radius: 30px;
  color: ${p => p.theme.colors.text.white};
  display: flex;
  height: 20px;
  padding: 0 9px;
  ${typo.caption500}
  ${boxShadowZ1}

  background-color: ${p => p.theme.colors.billing.plan.business.badge.bg};
  
  ${p => p.$plan === BillingPlan.Free && `
    background-color: ${p.theme.colors.billing.plan.free.badge.bg};
  `};

  ${p => p.$plan === BillingPlan.Standard && `
    background-color: ${p.theme.colors.billing.plan.standard.badge.bg};
  `};
`;
